import React, { useContext, useState, useRef } from "react";
import { mainContext } from "@ts/constants";
import SingleSelect from "@drop-downs/SingleSelect";
import { IMainContext, TOptions } from "@ts/common-types";
import { MdKeyboardArrowLeft, MdKeyboardArrowRight } from "react-icons/md";

interface IAssetPagination {
    pageLimit: number;
    setPageLimit: React.Dispatch<React.SetStateAction<number>>;
}

const AssetPagination: React.FC<IAssetPagination> = React.memo(({
    pageLimit,
    setPageLimit,
}) => {
    const { activePage, setActivePage, totalPages } =
        useContext<IMainContext>(mainContext);
    const selectRef = useRef(null);
    const [selectedValue, setSelectedValue] = useState(pageLimit);
    const options: TOptions[] = [
        { value: 25, label: 25 },
        { value: 50, label: 50 },
        { value: 75, label: 75 },
    ];
    const menuPlacement = "top";
    const handleChange = async (data: TOptions) => {
        setActivePage(1);
        setPageLimit(data.value);
        setSelectedValue(pageLimit);
    };

    const PaginationButtons = ({ direction }: { direction: string }) => {
        return (
            <>
                <button
                    className="pagination-btn d-flex justify-content-center align-items-center"
                    onClick={() => {
                        setActivePage((prev: number) => {
                            if (direction === "left" && prev !== 0) {
                                return prev - 1;
                            }
                            if (direction === "right" && prev !== totalPages) {
                                return prev + 1;
                            }
                        });
                    }}
                    disabled={
                        (direction === "left" && activePage === 1) ||
                        (direction === "right" && activePage === totalPages)
                    }
                    style={{fontSize: "18px"}}
                >
                    {direction === "right"? <MdKeyboardArrowRight/> : <MdKeyboardArrowLeft/>}
                </button>
            </>
        );
    };

    return (
        <>
            <div style={{ float: "right" }}>
                <div style={{ float: "left", marginRight: "1rem" }}>
                    <button
                        className="page-limit-btn-container"
                        onClick={() => {
                            if (selectRef.current) {
                                selectRef.current.focus();
                            }
                        }}
                    >
                        <SingleSelect
                            {...{
                                selectRef,
                                options,
                                handleChange,
                                selectedValue,
                                menuPlacement,
                            }}
                        />
                    </button>
                </div>
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                    }}
                >
                    <PaginationButtons direction="left" />
                    <div className="mx-2">
                        {activePage} of {totalPages}
                    </div>
                    <PaginationButtons direction="right" />
                </div>
            </div>
        </>
    );
});

export default AssetPagination;
